import { ShopEntity } from '../../schemas';
import { SHOPNET_SHOP_ID } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const isShopNetShop = (shop: ShopEntity | null): boolean => shop?.id === SHOPNET_SHOP_ID;
